import React from 'react'
import { NextPageContext } from 'next'
import dynamic from 'next/dynamic'
import {
  getServerSidePropsForGoogleTagManager,
  GoogleTagManagerHead,
  GoogleTagManagerHeadProps,
} from '../../../utils/analytics/google'

const ConditionalModal = dynamic(
  () => import('../../../components/upsell-modal/upsell-modal').then((res) => res.UpsellModal),
  {
    ssr: false,
  }
)

export async function getServerSideProps({ req, res }: NextPageContext) {
  const gtmProps = await getServerSidePropsForGoogleTagManager({ req, res } as NextPageContext)

  res!.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=7200')

  return { props: gtmProps }
}

export default function Index(props: GoogleTagManagerHeadProps) {
  const { dataLayer } = props
  return (
    <>
      <GoogleTagManagerHead dataLayer={dataLayer} />
      <ConditionalModal />
    </>
  )
}
